import React, { useState, useEffect, useContext, useRef } from "react";
import "emoji-mart/css/emoji-mart.css";
import { useParams } from "react-router-dom";
import MicRecorder from "mic-recorder-to-mp3";
import clsx from "clsx";
import imgDefault from "../../assets/files-icon-png-11.jpg"
import {
	Button,
	Box,
	FormControlLabel,
	Hidden,
	Menu,
	MenuItem,
	Switch,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import InputBase from "@material-ui/core/InputBase";
import CircularProgress from "@material-ui/core/CircularProgress";
import { green } from "@material-ui/core/colors";
import AttachFileIcon from "@material-ui/icons/AttachFile";
import SchedulesOutlinedIcon from "@material-ui/icons/Event";
import PhotoCameraIcon from "@material-ui/icons/PhotoCamera";
import PersonIcon from "@material-ui/icons/Person";
import AttachMoneyIcon from '@material-ui/icons/AttachMoney';
import IconButton from "@material-ui/core/IconButton";
import MoreVert from "@material-ui/icons/MoreVert";
import AddIcon from "@material-ui/icons/Add";
import MoodIcon from "@material-ui/icons/Mood";
import SendIcon from "@material-ui/icons/Send";
import ClearIcon from "@material-ui/icons/Clear";
import MicIcon from "@material-ui/icons/Mic";
import CheckCircleOutlineIcon from "@material-ui/icons/CheckCircleOutline";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import WhatsAppIcon from "@material-ui/icons/WhatsApp";
import PhotoLibraryIcon from "@material-ui/icons/PhotoLibrary";
import DescriptionIcon from "@material-ui/icons/Description";
import CloseIcon from '@material-ui/icons/Close';
import { i18n } from "../../translate/i18n";
import api from "../../services/api";
import RecordingTimer from "./RecordingTimer";
import { ReplyMessageContext } from "../../context/ReplyingMessage/ReplyingMessageContext";
import { AuthContext } from "../../context/Auth/AuthContext";
import { ThemeContext } from "../../context/Theme/ThemeContext";
import { useLocalStorage } from "../../hooks/useLocalStorage";
import toastError from "../../errors/toastError";
import { resolveMicrophoneAccessError } from "../../helpers/microphoneAccessError";
import { toast } from "react-toastify";
import EmailMessageModal from "../EmailMessageModal";
import WabaSendTemplateModal from "./WabaSendTemplateModal";
import ScheduleModal from "../ScheduleModal";
import CustomWebcam from "./CustomWebcam";
import { SendContactModal } from "./SendContactModal";
import TailwickComposerAttachMenu from "./TailwickComposerAttachMenu";
import { resolveMediaUrl } from "../../helpers/resolveMediaUrl";
import {
	stickerValidationMessage,
	validateStickerFile,
	validateStickerUrl,
} from "../../helpers/stickerValidation";
import TailwickComposerEmojiPicker from "./TailwickComposerEmojiPicker";
import ModalPessoaValor from "../modalPix";
import apiV2 from "../../services/apiV2.js";

const createMp3Recorder = () => new MicRecorder({ bitRate: 128 });

const postMediaToTicket = async ({ ticketId, ticketChannel, isConnected, formData }) => {
	if (isConnected) {
		await apiV2.post(`/hub/message/${ticketId}`, formData);
		return;
	}

	if (
		ticketChannel === "whatsappbusiness" ||
		ticketChannel === "whatsapp_business_account"
	) {
		await api.post(`/messages/${ticketId}`, formData);
		return;
	}

	await apiV2.post(`/message/${ticketId}`, formData);
};

const useStyles = makeStyles((theme) => ({
	mainWrapper: {
		borderRadius: "30px",
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
		[theme.breakpoints.down("sm")]: {
			position: "fixed",
			bottom: 0,
			width: "100%",
			left: 0,
		},
	},

	newMessageBox: {
		background: theme.palette.background.default,
		width: "100%",
		display: "flex",
		padding: "7px",
		alignItems: "center",
		borderRadius: 30,
	},

	hiddenInput: {
		display: "none",
	},

	messageInputWrapper: {
		// padding: 6,
		padding: "4px 12px",
		marginRight: 7,
		display: "flex",
		borderRadius: 8,
		flex: 1,
		position: "relative",
	},

	messageInput: {
		// paddingLeft: 10,
		flex: 1,
		border: "none",
	},

	sendMessageIcons: {

		margin: 0,
		padding: 0,
	},

	uploadInput: {
		display: "none",
		cursor: "pointer",
	},

	viewMediaInputWrapper: {
		height: "100%",
		width: "100%",
		flexDirection: "column",
		display: "flex",
		padding: "10px 13px",
		position: "absolute",
		alignItems: "center",
		backgroundColor: "#ffffff",
		top: "50%",
		left: "50%",
		transform: "translate(-50%, -50%)",
		justifyContent: "flex-start",
		zIndex: 40,
		boxShadow: "0 4px 24px rgba(0, 0, 0, 0.12)",
	},

	viewMediaInputWrapperDarkMode: {
		backgroundColor: "#1b1d1d",
		height: "100%",
		width: "100%",
		flexDirection: "column",
		display: "flex",
		padding: "10px 13px",
		position: "absolute",
		alignItems: "center",
		top: "50%",
		left: "50%",
		transform: "translate(-50%, -50%)",
		justifyContent: "flex-start",
		zIndex: 40,
		boxShadow: "0 4px 24px rgba(0, 0, 0, 0.35)",
	},

	mediaUploadCaptionRow: {
		display: "flex",
		flexDirection: "row",
		alignItems: "center",
		width: "100%",
		maxWidth: 720,
		gap: theme.spacing(1),
		marginTop: "auto",
		padding: theme.spacing(1, 1.5, 1.5),
		boxSizing: "border-box",
	},

	mediaUploadInputWrapper: {
		flex: 1,
		minWidth: 0,
		marginRight: 0,
		marginTop: 0,
		alignItems: "center",
	},

	mediaUploadSendBtn: {
		flexShrink: 0,
		display: "flex",
		alignItems: "center",
	},

	inputMenu: {
		display: "flex",
		flexDirection: "column",
	},

	// addIconMenuOpen: {
	//   transform: "rotate(45deg)",
	// },

	// animate add icon on open menu with rotate and back on close

	"@keyframes rotate": {
		"0%": {
			transform: "rotate(0deg)",
		},
		"100%": {
			transform: "rotate(135deg)",
		},
	},

	"@keyframes unrotate": {
		"0%": {
			transform: "rotate(135deg)",
		},
		"100%": {
			transform: "rotate(0deg)",
		},
	},

	addIconMenuOpen: {
		animation: `$rotate 0.3s ease-in-out`,
		transform: "rotate(135deg)",
		fontWeight: "900",

	},

	addIconMenuClosed: {
		animation: `$unrotate 0.3s ease-in-out`,
		fontWeight: "900",
	},

	emojiBox: {
		position: "absolute",
		bottom: 63,
		width: 40,
		borderTop: "1px solid #e8e8e8",
	},

	emojiBtn: {
		padding: 0,
		marginRight: 7,
		color: "#A5B0B8",
	},

	attachBtn: {
		padding: 0,
	},

	menuItem: {
		cursor: "pointer",
	},

	circleLoading: {
		color: green[500],
		opacity: "70%",
		position: "absolute",
		top: "20%",
		left: "50%",
		marginLeft: -12,
	},

	audioLoading: {
		color: green[500],
		opacity: "70%",
	},

	recorderWrapper: {
		display: "flex",
		alignItems: "center",
		alignContent: "middle",
	},

	cancelAudioIcon: {
		color: "red",
	},

	sendAudioIcon: {
		color: "green",
	},

	replyginMsgWrapper: {
		display: "flex",
		width: "100%",
		alignItems: "center",
		justifyContent: "center",
		paddingTop: 8,
		paddingLeft: 20,
		paddingRight: 7,
		paddingBottom: 10,
	},

	replyginMsgContainer: {
		flex: 1,
		marginRight: 5,
		overflowY: "hidden",
		backgroundColor: "rgba(0, 0, 0, 0.05)",
		borderRadius: "7.5px",
		display: "flex",
		position: "relative",
	},

	replyginMsgBody: {
		padding: 10,
		height: "auto",
		display: "block",
		whiteSpace: "pre-wrap",
		overflow: "hidden",
	},

	replyginMsgWrapperDarkMode: {
		display: "flex",
		width: "100%",
		alignItems: "center",
		justifyContent: "center",
		paddingTop: 8,
		paddingLeft: 20,
		paddingRight: 7,
		paddingBottom: 10,
		backgroundColor: "#1b1d1d",
	},

	replyginMsgContainerDarkMode: {
		flex: 1,
		marginRight: 5,
		overflowY: "hidden",
		borderRadius: "7.5px",
		display: "flex",
		position: "relative",
		backgroundColor: "#2e2e2e",
	},

	replyginContactMsgSideColor: {
		flex: "none",
		width: "4px",
		backgroundColor: "#35cd96",
	},

	replyginSelfMsgSideColor: {
		flex: "none",
		width: "4px",
		backgroundColor: "#6bcbef",
	},

	messageContactName: {
		display: "flex",
		color: "#6bcbef",
		fontWeight: 500,
	},

	iconeSendMessage: {
		backgroundColor: "#4FBC84",
		"&:hover": {
			backgroundColor: "#4cb27d "
		}
	},
	micPermissionAlert: {
		width: "100%",
		display: "flex",
		alignItems: "flex-start",
		justifyContent: "space-between",
		gap: 12,
		padding: "10px 12px",
		marginBottom: 8,
		borderRadius: 8,
		border: "1px solid #f59e0b",
		backgroundColor: "#fffbeb",
		color: "#92400e",
	},
	micPermissionAlertDark: {
		border: "1px solid #b45309",
		backgroundColor: "#422006",
		color: "#fde68a",
	},
	micPermissionAlertTitle: {
		display: "block",
		fontSize: 14,
		fontWeight: 600,
		marginBottom: 4,
	},
	micPermissionAlertText: {
		margin: 0,
		fontSize: 13,
		lineHeight: 1.45,
	},
	micPermissionAlertHint: {
		margin: "6px 0 0",
		fontSize: 12,
		lineHeight: 1.45,
		opacity: 0.9,
	},
	micPermissionAlertDismiss: {
		flexShrink: 0,
		border: 0,
		borderRadius: 6,
		padding: "6px 10px",
		fontSize: 12,
		fontWeight: 600,
		cursor: "pointer",
		backgroundColor: "#f59e0b",
		color: "#fff",
	},
	iconeSendVoice: {
		backgroundColor: "#00000",
		"&:hover": {
			backgroundColor: "#4FBC84 "
		}
	},
	messageQuickAnswersWrapper: {
		maxHeight: "50vh",
		overflowY: "auto",
		margin: 0,
		position: "absolute",
		bottom: "50px",
		background: "#ffffff",
		padding: "2px",
		border: "1px solid #CCC",
		left: 0,
		width: "100%",
		"& li": {
			listStyle: "none",
			"& a": {
				display: "block",
				padding: "8px",
				textOverflow: "ellipsis",
				overflow: "hidden",
				maxHeight: "32px",
				"&:hover": {
					background: "#F1F1F1",
					cursor: "pointer",
				},
			},
		},
	},
}));

function MessageInput({
	ticketStatus,
	ticketChannel,
	ticketOwnerId,
	templateBarStatus,
	ticket,
	whatsappId,
	ticketId: ticketIdProp,
	tailwickLayout = false,

}) {
	const classes = useStyles();
	const { ticketId: ticketIdParam } = useParams();

	const ticketId = ticketIdProp ?? ticketIdParam;

	const [sendContactsModalOpen, setSendContactsModalOpen] = useState(false);
	const [scheduleModalOpen, setScheduleModalOpen] = useState(false);
	const [medias, setMedias] = useState([]);
	const [inputMessage, setInputMessage] = useState("");
	const [showEmoji, setShowEmoji] = useState(false);
	const [loading, setLoading] = useState(false);
	const [recording, setRecording] = useState(false);
	const [micAccessError, setMicAccessError] = useState(null);
	const [quickAnswers, setQuickAnswer] = useState([]);
	const [typeBar, setTypeBar] = useState(false);
	const [emailModalOpen, setEmailModalOpen] = useState(false);
	const inputRef = useRef();
	const emojiAnchorRef = useRef(null);
	const mp3RecorderRef = useRef(null);
	const [recordingSessionId, setRecordingSessionId] = useState(0);
	const [anchorEl, setAnchorEl] = useState(null);
	const [templateModalOpen, setTemplateModalOpen] = useState(false);
	const { setReplyingMessage, replyingMessage } =
		useContext(ReplyMessageContext);
	const { user } = useContext(AuthContext);
	const { darkMode } = useContext(ThemeContext);
	const [isCamOn, setIsCamOn] = useState(false);
	const [preview, setPreview] = useState(null);
	const [previewType, setPreviewType] = useState("");
	const [messageFile, setMessageFile] = useState("")
	const [mediaUrl, setMediaUrl] = useState("")
	const [signMessage, setSignMessage] = useLocalStorage("signOption", true);
	const [isConnected, setIsConnected] = useState(false);

	const [modalPix, setModalPix] = useState(false);
	const [stickerPickerOpen, setStickerPickerOpen] = useState(false);
	const [reactionPickerTab, setReactionPickerTab] = useState("emoji");
	const stickerAnchorRef = useRef(null);

	useEffect(() => {
		if (!whatsappId) return;

		const fetchConnection = async () => {
			try {
				const { data } = await api.get(`/hub-ticketId/${whatsappId}`);
				setIsConnected(!!data);
			} catch (err) {
				setIsConnected(false);
			}
		};

		fetchConnection();
	}, [whatsappId]);


	useEffect(() => {
		inputRef.current.focus();
	}, [replyingMessage]);

	useEffect(() => {
		inputRef.current.focus();
		return () => {
			setInputMessage("");
			setShowEmoji(false);
			setMedias([]);
			setReplyingMessage(null);
			if (mp3RecorderRef.current) {
				try {
					mp3RecorderRef.current.stop();
				} catch (_) {
					// ignore cleanup errors
				}
				mp3RecorderRef.current = null;
			}
			setRecording(false);
			setMicAccessError(null);
		};
	}, [ticketId, setReplyingMessage]);

	const stopActiveRecorder = () => {
		if (!mp3RecorderRef.current) return;
		try {
			mp3RecorderRef.current.stop();
		} catch (_) {
			// ignore stop errors
		}
		mp3RecorderRef.current = null;
	};

	const handleChangeInput = (e) => {
		setInputMessage(e.target.value);
		handleLoadQuickAnswer(e.target.value);
	};

	const handleQuickAnswersClick = (value) => {
		setInputMessage(value.message);
		setTypeBar(false);

		if (value.file && value.file.length > 0) {
			setMedias([1]);
			setPreview(value.file);
			setPreviewType("image");
			setMessageFile(value.message);
			setMediaUrl(value.file);
		}
	};

	const handleAddEmoji = (e) => {
		const emoji = e.native;
		setInputMessage((prevState) => prevState + emoji);
		setMessageFile((prevState) => prevState + emoji);
	};

	const handleChangeMedias = (e) => {
		const file = e.target.files[0];

		console.log("fileType", file.type.split("/")[0])

		if (file) {
			const fileType = file.type.split("/")[0];
			if (fileType === "image") {
				const reader = new FileReader();
				reader.onloadend = () => {
					setPreview(reader.result);
					setPreviewType("image");
				};
				reader.readAsDataURL(file);
			} else if (fileType === "video") {
				const videoUrl = URL.createObjectURL(file);
				setPreview(videoUrl);
				setPreviewType("video");
			} else {
				setPreview(imgDefault);
				setPreviewType("image");
			}
		}

		if (!e.target.files) {
			return;
		}

		const selectedMedias = Array.from(e.target.files);
		setMedias(selectedMedias);
	};

	const handleSavePix = async (dados) => {
		console.log('Dados salvos:', dados);

		try {
			const response = await apiV2.post(`/gerarPix/${ticketId}`, dados);
			console.log(response)
		} catch (e) {
			console.log(e)
		}

	};


	const handleInputPaste = (e) => {
        if (e.clipboardData.files[0]) {
            const file = e.clipboardData.files[0];
            setMedias([file]);
            const url = URL.createObjectURL(file);

            if(file.type.startsWith("image/")){
                setPreview(url);
            }else{
                setPreview(imgDefault);
            }
            setPreviewType("image");
        }
	};

	const handleUploadMedia = async (e) => {
		setLoading(true);
		e.preventDefault();

		const formData = new FormData();
		formData.append("fromMe", true);

		if (mediaUrl.length > 0) {
			formData.append("mediaUrl", mediaUrl);
		} else {
			medias.forEach((media) => {
				formData.append("medias", media);
				formData.append("body", media.name);
			});
		}


		formData.append("caption", messageFile);
		try {
			if (isConnected) {

				await apiV2.post(`/hub/message/${ticketId}`, formData);
			} else {
				await postMediaToTicket({
					ticketId,
					ticketChannel,
					isConnected,
					formData,
				});
			}
		} catch (err) {
			toastError(err);
		}
		setMediaUrl("")
		setInputMessage("")
		setMessageFile("")
		setLoading(false);
		setMedias([]);
		setIsCamOn(false);
	};

	const handleSendSavedSticker = async (sticker) => {
		if (!sticker?.mediaUrl || loading || ticketStatus !== "open") return;
		setLoading(true);
		try {
			const mediaUrl = resolveMediaUrl(sticker.mediaUrl);
			const validation = await validateStickerUrl(mediaUrl);
			if (!validation.ok) {
				toast.error(
					stickerValidationMessage(validation, (key) => i18n.t(key))
				);
				return;
			}

			const formData = new FormData();
			formData.append("fromMe", true);
			formData.append("mediaUrl", mediaUrl);
			formData.append("fileMimeType", "sticker");
			formData.append("mediaType", "sticker");
			formData.append("caption", "");

			if (isConnected) {
				await apiV2.post(`/hub/message/${ticketId}`, formData);
			} else {
				await postMediaToTicket({
					ticketId,
					ticketChannel,
					isConnected,
					formData,
				});
			}
		} catch (err) {
			toastError(err);
		} finally {
			setLoading(false);
		}
	};

	const handleUploadNewSticker = async (event) => {
		const file = event?.target?.files?.[0];
		if (!file || loading || ticketStatus !== "open") return;

		const validation = validateStickerFile(file);
		if (!validation.ok) {
			toast.error(
				stickerValidationMessage(validation, (key) => i18n.t(key))
			);
			if (event?.target) event.target.value = "";
			return;
		}

		setLoading(true);
		try {
			const formData = new FormData();
			formData.append("fromMe", true);
			formData.append("medias", file);
			formData.append("body", file.name || "Figurinha");
			formData.append("caption", "");
			formData.append("fileMimeType", "sticker");
			formData.append("mediaType", "sticker");

			if (isConnected) {
				await apiV2.post(`/hub/message/${ticketId}`, formData);
			} else {
				await postMediaToTicket({
					ticketId,
					ticketChannel,
					isConnected,
					formData,
				});
			}
		} catch (err) {
			toastError(err);
		} finally {
			setLoading(false);
			if (event?.target) event.target.value = "";
		}
	};

	const handleToggleReactionPicker = (event) => {
		if (event?.currentTarget) {
			stickerAnchorRef.current = event.currentTarget;
		} else if (emojiAnchorRef.current) {
			stickerAnchorRef.current = emojiAnchorRef.current;
		}

		if (showEmoji || stickerPickerOpen) {
			setShowEmoji(false);
			setStickerPickerOpen(false);
			return;
		}
		setReactionPickerTab("emoji");
		setStickerPickerOpen(true);
	};

	const handleSendMessage = async () => {
		if (inputMessage.trim() === "") return;
		setLoading(true);

		const message = {
			read: 1,
			fromMe: true,
			mediaUrl: "",
			body: signMessage
				? `*${user?.name}:*\n${inputMessage.trim()}`
				: inputMessage.trim(),
			quotedMsg: replyingMessage,
		};

		try {

			if (isConnected) {
				await apiV2.post(`/hub/message/${ticketId}`, message);
				setMessageFile("")
				setInputMessage("");
				setShowEmoji(false);
				setLoading(false);
				setReplyingMessage(null);
				return;
			}

			if (
				ticketChannel === "whatsappbusiness" ||
				ticketChannel === "whatsapp_business_account"
			) {
				await api.post(`/messages/${ticketId}`, message);

				setMessageFile("")
				setInputMessage("");
				setShowEmoji(false);
				setLoading(false);
				setReplyingMessage(null);

				return;
			}

			await apiV2.post(`/message/${ticketId}`, message);


		} catch (err) {
			toastError(err);
		}
		setMessageFile("")
		setInputMessage("");
		setShowEmoji(false);
		setLoading(false);
		setReplyingMessage(null);
	};

	const handleStartRecording = async () => {
		if (recording || loading || ticketStatus !== "open" || templateBarStatus) return;

		setLoading(true);
		try {
			stopActiveRecorder();
			const recorder = createMp3Recorder();
			await recorder.start();
			mp3RecorderRef.current = recorder;
			setRecordingSessionId((prev) => prev + 1);
			setRecording(true);
			setMicAccessError(null);
		} catch (err) {
			stopActiveRecorder();
			const micError = resolveMicrophoneAccessError(err);
			if (micError) {
				setMicAccessError(micError);
				toast.error(i18n.t(micError.messageKey), {
					toastId: `mic-error-${micError.type}`,
					autoClose: 8000,
				});
			} else {
				toastError(err);
			}
		} finally {
			setLoading(false);
		}
	};

	const handleLoadQuickAnswer = async (value) => {
		if (value && value.indexOf("/") === 0) {
			try {
				const { data } = await api.get("/quickAnswers/", {
					params: { searchParam: value.substring(1) },
				});

				setQuickAnswer(data.quickAnswers);
				if (data.quickAnswers.length > 0) {
					setTypeBar(true);
				} else {
					setTypeBar(false);
				}
			} catch (err) {
				setTypeBar(false);
			}
		} else {
			setTypeBar(false);
		}
	};

	const handleUploadAudio = async () => {
		const recorder = mp3RecorderRef.current;
		if (!recorder) {
			setRecording(false);
			return;
		}

		setLoading(true);
		try {
			const [, blob] = await recorder.stop().getMp3();
			mp3RecorderRef.current = null;

			if (blob.size < 10000) {
				toastError(new Error("Áudio muito curto. Grave novamente."));
				setRecording(false);
				return;
			}

			const formData = new FormData();
			const filename = `${new Date().getTime()}.mp3`;
			formData.append("medias", blob, filename);
			formData.append("body", filename);
			formData.append("fromMe", true);

			await postMediaToTicket({
				ticketId,
				ticketChannel,
				isConnected,
				formData,
			});
		} catch (err) {
			toastError(err);
		} finally {
			setRecording(false);
			setLoading(false);
		}
	};

	const handleCancelAudio = () => {
		stopActiveRecorder();
		setRecording(false);
	};

	const handleOpenMenuClick = (event) => {
		setAnchorEl(event.currentTarget);
	};

	const handleMenuItemClick = (event) => {
		setAnchorEl(null);
	};

	const handleCameraClick = () => {
		setAnchorEl(null);
		setIsCamOn(true);
	};

	const handleCloseWebcam = () => {
		setIsCamOn(false);
	};

	const handleWebcamCapture = (file) => {
		setMedias([file]);
		const reader = new FileReader();
		reader.onloadend = () => {
			setPreview(reader.result);
			setPreviewType("image");
		};
		reader.readAsDataURL(file);
		setIsCamOn(false);
	};

	const renderMicAccessAlert = () => {
		if (!micAccessError) return null;

		return (
			<div
				className={clsx(
					tailwickLayout
						? "tailwick-mic-permission-alert"
						: clsx(
							classes.micPermissionAlert,
							darkMode && classes.micPermissionAlertDark
						)
				)}
				role="alert"
			>
				<div>
					<strong className={!tailwickLayout ? classes.micPermissionAlertTitle : undefined}>
						{i18n.t(micAccessError.titleKey)}
					</strong>
					<p className={!tailwickLayout ? classes.micPermissionAlertText : "tailwick-mic-permission-alert__text"}>
						{i18n.t(micAccessError.messageKey)}
					</p>
					{micAccessError.hintKey && (
						<p
							className={
								!tailwickLayout
									? classes.micPermissionAlertHint
									: "tailwick-mic-permission-alert__hint"
							}
						>
							{i18n.t(micAccessError.hintKey)}
						</p>
					)}
				</div>
				<button
					type="button"
					className={
						tailwickLayout
							? "tailwick-mic-permission-alert__dismiss btn btn-sm btn-warning"
							: classes.micPermissionAlertDismiss
					}
					onClick={() => setMicAccessError(null)}
				>
					{i18n.t("messagesInput.dismissMicAlert")}
				</button>
			</div>
		);
	};

	const getReplyPreviewText = (message) => {
		if (message?.body) return message.body;
		const labels = {
			image: "Imagem",
			video: "Vídeo",
			audio: "Áudio",
			document: "Documento",
			sticker: "Figurinha",
			location: "Localização",
			vcard: "Contato",
		};
		return labels[message?.mediaType] || "";
	};

	const renderReplyingMessage = (message) => {
		if (tailwickLayout) {
			return (
				<div className="tailwick-reply-preview">
					<div className="tailwick-reply-preview__bar">
						<span
							className={clsx("tailwick-reply-preview__accent", {
								"tailwick-reply-preview__accent--self": !message.fromMe,
							})}
						/>
						<div className="tailwick-reply-preview__body">
							{!message.fromMe && (
								<span className="tailwick-reply-preview__name">
									{message.contact?.name}
								</span>
							)}
							<span className="tailwick-reply-preview__text">
								{getReplyPreviewText(message)}
							</span>
						</div>
						<button
							type="button"
							className="tailwick-reply-preview__close"
							disabled={loading || ticketStatus !== "open" || templateBarStatus}
							onClick={() => setReplyingMessage(null)}
							aria-label="Cancelar resposta"
						>
							<svg
								className="size-4"
								viewBox="0 0 24 24"
								fill="none"
								stroke="currentColor"
								strokeWidth="2"
								aria-hidden
							>
								<path d="M18 6 6 18" />
								<path d="m6 6 12 12" />
							</svg>
						</button>
					</div>
				</div>
			);
		}

		return (
			<div
				className={
					darkMode
						? classes.replyginMsgWrapperDarkMode
						: classes.replyginMsgWrapper
				}
			>
				<div
					className={
						darkMode
							? classes.replyginMsgContainerDarkMode
							: classes.replyginMsgContainer
					}
				>
					<span
						className={clsx(classes.replyginContactMsgSideColor, {
							[classes.replyginSelfMsgSideColor]: !message.fromMe,
						})}
					/>
					<div className={classes.replyginMsgBody}>
						{!message.fromMe && (
							<span className={classes.messageContactName}>
								{message.contact?.name}
							</span>
						)}
						{message.body}
					</div>
					<IconButton
						style={{ position: "absolute", top: "10%", right: "10px" }}
						aria-label="showRecorder"
						component="span"
						disabled={loading || ticketStatus !== "open" || templateBarStatus}
						onClick={() => setReplyingMessage(null)}
					>
						<ClearIcon className={classes.sendMessageIcons} />
					</IconButton>
				</div>

			</div>
		);
	};

	const tailwickActionDisabled =
		loading || recording || ticketStatus !== "open" || templateBarStatus;
	const tailwickSendDisabled =
		!String(inputMessage || "").trim() || loading || templateBarStatus;

	const tailwickEmojiDisabled =
		loading || recording || ticketStatus !== "open" || templateBarStatus;

	const renderEmojiPickerPopover = () => null;

	const reactionPicker = (
		<TailwickComposerEmojiPicker
			open={stickerPickerOpen || showEmoji}
			anchorEl={stickerAnchorRef.current || emojiAnchorRef.current}
			darkMode={darkMode}
			disabled={tailwickEmojiDisabled}
			initialTab={reactionPickerTab}
			onClose={() => {
				setShowEmoji(false);
				setStickerPickerOpen(false);
			}}
			onSelectEmoji={handleAddEmoji}
			onSelectSticker={handleSendSavedSticker}
			onUploadNew={handleUploadNewSticker}
		/>
	);

	const renderTailwickEmojiButton = (disabled = tailwickEmojiDisabled) => (
			<button
				ref={emojiAnchorRef}
				type="button"
				className={clsx(
					"tailwick-composer-emoji-btn",
					disabled && "opacity-50",
					(showEmoji || stickerPickerOpen) && "tailwick-composer-emoji-btn--open"
				)}
				disabled={disabled}
				onClick={handleToggleReactionPicker}
				aria-label="emojiPicker"
				aria-expanded={showEmoji || stickerPickerOpen}
			>
				<svg
					className="size-[20px] shrink-0"
					viewBox="0 0 24 24"
					fill="none"
					stroke="currentColor"
					strokeWidth="1.8"
					aria-hidden
				>
					<circle cx="12" cy="12" r="10" />
					<path d="M8 14s1.5 2 4 2 4-2 4-2" />
					<line x1="9" y1="9" x2="9.01" y2="9" />
					<line x1="15" y1="9" x2="15.01" y2="9" />
				</svg>
			</button>
	);

	if (medias.length > 0) {
		const MediaUploadShell = tailwickLayout ? "div" : Paper;
		const mediaUploadShellProps = tailwickLayout
			? {
				className: "tailwick-media-upload-panel",
			}
			: {
				elevation: 0,
				square: true,
				className: darkMode
					? classes.viewMediaInputWrapperDarkMode
					: classes.viewMediaInputWrapper,
			};

		return (
			<>
				{reactionPicker}
				<MediaUploadShell {...mediaUploadShellProps}>
					{loading ? (
						<div>
							<CircularProgress className={classes.circleLoading} />
						</div>
					) : (
						<div
							className={
								tailwickLayout ? "tailwick-media-upload-panel__preview-wrap" : undefined
							}
							style={
								tailwickLayout
									? undefined
									: {
										display: "flex",
										flexDirection: "column",
										justifyContent: "center",
										alignItems: "center",
										width: "100%",
										flex: 1,
										minHeight: "12rem",
									}
							}
						>
							<IconButton
								aria-label="cancel-upload"
								component="span"
								onClick={(e) => setMedias([])}
								style={
									tailwickLayout
										? { position: "absolute", top: 12, left: 12, zIndex: 2 }
										: { position: "absolute", top: 80, left: 20, zIndex: 1 }
								}
							>
								<CloseIcon className={classes.sendMessageIcons} />
							</IconButton>
							{preview && previewType === "image" && (
								<img
									src={preview}
									alt="Preview"
									className={tailwickLayout ? "tailwick-media-upload-panel__preview" : undefined}
									style={
										tailwickLayout
											? undefined
											: {
												width: "auto",
												height: "auto",
												maxWidth: "min(96%, 720px)",
												maxHeight: "min(72vh, 640px)",
												marginBottom: "12px",
												objectFit: "contain",
											}
									}
								/>
							)}

							{preview && previewType === "video" && (
								<video
									className={tailwickLayout ? "tailwick-media-upload-panel__preview" : undefined}
									style={
										tailwickLayout
											? undefined
											: {
												width: "auto",
												maxWidth: "min(96%, 720px)",
												maxHeight: "min(72vh, 640px)",
												marginBottom: "12px",
											}
									}
									controls
								>
									<source src={preview} type="video/mp4" />
									Seu navegador não suporta o elemento de vídeo.
								</video>
							)}
						</div>
					)}
					<div
						className={
							tailwickLayout
								? "tailwick-media-upload-panel__caption tailwick-composer-row"
								: classes.mediaUploadCaptionRow
						}
					>
						<div
							className={clsx(
								classes.messageInputWrapper,
								!tailwickLayout && classes.mediaUploadInputWrapper
							)}
							style={
								tailwickLayout
									? undefined
									: {
										backgroundColor: `${darkMode ? "#242626" : "#F7F5F3"}`,
									}
							}
						>
							<InputBase
								inputRef={(input) => {
									input && input.focus();
									input && (inputRef.current = input);
								}}
								className={[
									classes.messageInput,
									ticketChannel === "email" ? classes.hiddenInput : "",
								].join(" ")}
								placeholder={"Adicione uma legenda"
								}
								multiline
								maxRows={5}
								value={messageFile}
								onChange={(e) => setMessageFile(e.target.value)}
								endAdornment={
									tailwickLayout ? null : (
										<IconButton
											aria-label="emojiPicker"
											component="span"
											disabled={
												loading ||
												recording ||
												ticketStatus !== "open" ||
												templateBarStatus
											}
											onClick={handleToggleReactionPicker}
											className={classes.emojiBtn}
										>
											<MoodIcon
												style={{
													color: `${darkMode ? "#fff" : "#000000"}`,
												}}
											/>
										</IconButton>
									)
								}
							/>
							{!tailwickLayout && renderEmojiPickerPopover()}
						</div>
						{tailwickLayout ? (
							<div className="tailwick-composer-actions flex shrink-0 items-center gap-2">
								{renderTailwickEmojiButton(loading || templateBarStatus)}
								<button
									type="button"
									className={clsx(
										"btn btn-icon size-9 shrink-0 bg-primary/10 text-primary hover:bg-primary/20",
										(loading || templateBarStatus) && "opacity-50"
									)}
									aria-label="send-upload"
									disabled={loading || templateBarStatus}
									onClick={handleUploadMedia}
								>
									<svg
										xmlns="http://www.w3.org/2000/svg"
										width="18"
										height="18"
										viewBox="0 0 24 24"
										fill="none"
										stroke="currentColor"
										strokeWidth="2"
										aria-hidden
									>
										<path d="m22 2-7 20-4-9-9-4Z" />
										<path d="M22 2 11 13" />
									</svg>
								</button>
							</div>
						) : (
							<div className={classes.mediaUploadSendBtn}>
								<IconButton
									aria-label="send-upload"
									component="span"
									onClick={handleUploadMedia}
									disabled={loading || templateBarStatus}
									className={classes.iconeSendMessage}
									style={{ color: `${darkMode ? "#000000" : "#fff"}` }}
								>
									<SendIcon className={classes.sendMessageIcons} fontSize="large" />
								</IconButton>
							</div>
						)}
					</div>


				</MediaUploadShell>
			</>
		);
	}

	const renderTailwickComposerActions = () => {
		if (recording) {
			return (
				<div
					className={clsx(
						classes.recorderWrapper,
						"tailwick-composer-recording flex shrink-0 items-center gap-0.5"
					)}
				>
					<button
						type="button"
						className="tailwick-composer-infield-btn"
						disabled={loading || templateBarStatus}
						onClick={handleCancelAudio}
						aria-label="Cancelar gravação"
					>
						<HighlightOffIcon fontSize="small" />
					</button>
					{loading ? (
						<CircularProgress size={16} className={classes.audioLoading} />
					) : (
						<RecordingTimer key={recordingSessionId} />
					)}
					<button
						type="button"
						className="tailwick-composer-infield-btn tailwick-composer-infield-btn--accent"
						disabled={loading || templateBarStatus}
						onClick={handleUploadAudio}
						aria-label="Enviar áudio"
					>
						<CheckCircleOutlineIcon fontSize="small" />
					</button>
				</div>
			);
		}

		const hasText = Boolean(String(inputMessage || "").trim());

		if (hasText) {
			return (
				<button
					type="button"
					className={clsx(
						"tailwick-composer-infield-btn tailwick-composer-infield-btn--accent",
						tailwickSendDisabled && "opacity-50"
					)}
					disabled={tailwickSendDisabled}
					onClick={handleSendMessage}
					aria-label="Enviar mensagem"
				>
					<svg
						xmlns="http://www.w3.org/2000/svg"
						width="20"
						height="20"
						viewBox="0 0 24 24"
						fill="currentColor"
						aria-hidden
					>
						<path d="M2.01 21 23 12 2.01 3 2 10l15 2-15 2z" />
					</svg>
				</button>
			);
		}

		return (
			<button
				type="button"
				className={clsx(
					"tailwick-composer-infield-btn",
					tailwickActionDisabled && "opacity-50"
				)}
				disabled={tailwickActionDisabled}
				onClick={handleStartRecording}
				aria-label="Gravar áudio"
			>
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="20"
					height="20"
					viewBox="0 0 24 24"
					fill="currentColor"
					aria-hidden
				>
					<path d="M12 14c1.66 0 3-1.34 3-3V5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3z" />
					<path d="M17 11c0 2.76-2.24 5-5 5s-5-2.24-5-5H5c0 3.53 2.61 6.43 6 6.92V21h2v-3.08c3.39-.49 6-3.39 6-6.92h-2z" />
				</svg>
			</button>
		);
	};

	return (
		<Paper
			square
			elevation={0}
			component={tailwickLayout ? "div" : undefined}
			className={clsx(
				classes.mainWrapper,
				tailwickLayout && "tailwick-message-input tailwick-composer-root w-full"
			)}
			style={
				tailwickLayout
					? undefined
					: { backgroundColor: `${darkMode ? "#1b1d1d" : "#ffff"}` }
			}
		>
			{reactionPicker}
			{renderMicAccessAlert()}
			{replyingMessage && renderReplyingMessage(replyingMessage)}

			<SendContactModal
				modalOpen={sendContactsModalOpen}
				onClose={() => setSendContactsModalOpen(false)}
				ticketId={ticketId}
				whatsappId={whatsappId}
			/>

			<ScheduleModal
				open={scheduleModalOpen}
				onClose={() => setScheduleModalOpen(false)}
				aria-labelledby="form-dialog-title"
				scheduleId={null}
				contact={ticket?.contact}
			/>

			<CustomWebcam
				open={isCamOn}
				onClose={handleCloseWebcam}
				onCapture={handleWebcamCapture}
			/>

			<div
				className={clsx(classes.newMessageBox, tailwickLayout && "tailwick-composer-row")}

			>
				{ticketChannel === "email" && (
					<Box
						component="div"
						width="100%"
						display="flex"
						alignContent="center"
						py={2}
						justifyContent="center"
					>
						<Button
							variant="contained"
							color="primary"
							onClick={() => setEmailModalOpen(true)}
							disabled={
								user.id !== ticketOwnerId ||
								ticketStatus === "closed" ||
								templateBarStatus
							}
						>
							{ticketStatus === "closed"
								? "Reabrea o ticket para encaminhar novos emails"
								: "Enviar email"}
						</Button>
						<EmailMessageModal
							modalOpened={emailModalOpen}
							handleModalOpened={setEmailModalOpen}
							ticketId={ticketId}
						/>
					</Box>
				)}

				{!tailwickLayout && ticketChannel !== "email" && (
					<Hidden only={["sm", "xs"]}>
						{ticketChannel === "whatsapp_business_account" && (
							<>
								<Button
									disabled={loading || recording || ticketStatus !== "open"}
									onClick={() => setTemplateModalOpen(true)}
								>
									<WhatsAppIcon
										color={
											loading || recording || ticketStatus !== "open"
												? "disabled"
												: "primary"
										}
									/>
								</Button>
								{templateModalOpen && (
									<WabaSendTemplateModal
										whatsappId={whatsappId}
										open={templateModalOpen}
										closeModalFn={() => setTemplateModalOpen(false)}
										ticketId={ticketId}
									/>
								)}
							</>
						)}

						{ticketChannel === "whatsappbusiness" && (
							<>
								<Button
									disabled={loading || recording || ticketStatus !== "open"}
									onClick={() => setTemplateModalOpen(true)}
								>
									<WhatsAppIcon
										color={
											loading || recording || ticketStatus !== "open"
												? "disabled"
												: "primary"
										}
									/>
								</Button>
								{templateModalOpen && (
									<WabaSendTemplateModal
										whatsappId={whatsappId}
										open={templateModalOpen}
										closeModalFn={() => setTemplateModalOpen(false)}
										ticketId={ticketId}
									/>
								)}
							</>
						)}

						<IconButton
							aria-controls="simple-menu"
							aria-haspopup="true"
							onClick={handleOpenMenuClick}
						>
							<AddIcon style={{ color: `${darkMode ? "#fff" : "#000000"}`, }}
								className={
									Boolean(anchorEl)
										? classes.addIconMenuOpen
										: classes.addIconMenuClosed
								}
							/>
						</IconButton>
						<Menu
							id="simple-menu"
							keepMounted
							anchorEl={anchorEl}
							open={Boolean(anchorEl)}
							onClose={handleMenuItemClick}
							className={classes.inputMenu}
							anchorOrigin={{
								vertical: "top",
								horizontal: "left",
							}}
							transformOrigin={{
								vertical: "bottom",
								horizontal: "left",
							}}
							style={{
								marginBottom: "-50px",
							}}
						>
							{/* <MenuItem  onClick={handleMenuItemClick}>
								<input
									multiple
									type="file"
									id="upload-button"
									disabled={
										loading ||
										recording ||
										ticketStatus !== "open" ||
										templateBarStatus
									}
									className={classes.uploadInput}
									onChange={handleChangeMedias}
								/>
								<label htmlFor="upload-button">
									<IconButton
										aria-label="upload"
										component="span"
										disabled={
											loading ||
											recording ||
											ticketStatus !== "open" ||
											templateBarStatus
										}
									>
										<AttachFileIcon className={classes.sendMessageIcons} />
									</IconButton>
									Mídias
								</label>
							</MenuItem> */}

							<MenuItem onClick={handleMenuItemClick}>
								<input
									multiple
									type="file"
									accept=".pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt"
									id="upload-button-document"
									disabled={
										loading ||
										recording ||
										ticketStatus !== "open" ||
										templateBarStatus
									}
									className={classes.uploadInput}
									onChange={handleChangeMedias}
								/>
								<label htmlFor="upload-button-document">
									<IconButton
										aria-label="upload"
										component="span"
										disabled={
											loading ||
											recording ||
											ticketStatus !== "open" ||
											templateBarStatus
										}
										className={classes.attachBtn}
									>
										<DescriptionIcon
											style={{
												color: "#7F66FF",
												marginRight: "0.5rem",
											}}
										/>
									</IconButton>
									Documento
								</label>
							</MenuItem>

							<MenuItem onClick={handleMenuItemClick} >
								<input
									multiple
									type="file"
									accept="image/*,video/*"
									id="upload-button-media"
									disabled={
										loading ||
										recording ||
										ticketStatus !== "open" ||
										templateBarStatus
									}
									className={classes.uploadInput}
									onChange={handleChangeMedias}
								/>
								<label htmlFor="upload-button-media">
									<IconButton
										aria-label="upload"
										component="span"
										disabled={
											loading ||
											recording ||
											ticketStatus !== "open" ||
											templateBarStatus
										}
										className={classes.attachBtn}
									>
										<PhotoLibraryIcon
											style={{
												color: "#017BFC",
												marginRight: "0.5rem",
											}}
										/>
									</IconButton>
									Fotos e vídeos
								</label>
							</MenuItem>

							<MenuItem
								onClick={() => {
									handleMenuItemClick();
									handleCameraClick();
								}}
							>
								<IconButton
									aria-label="upload"
									component="span"
									disabled={
										loading ||
										recording ||
										ticketStatus !== "open" ||
										templateBarStatus
									}
									className={classes.attachBtn}
								>
									<PhotoCameraIcon
										style={{
											color: "#FF3074",
											marginRight: "0.5rem",
										}}
									/>
								</IconButton>
								Câmera
							</MenuItem>

							<MenuItem
								onClick={() => {
									handleMenuItemClick();
									setSendContactsModalOpen(true);
								}}
							>
								<IconButton
									aria-label="upload"
									component="span"
									disabled={
										loading ||
										recording ||
										ticketStatus !== "open" ||
										templateBarStatus
									}
									className={classes.attachBtn}
								>
									<PersonIcon
										style={{
											color: "#019DE1",
											marginRight: "0.5rem",
										}}
									/>
								</IconButton>
								Contato
							</MenuItem>

							<MenuItem
								onClick={() => {
									handleMenuItemClick();
									setScheduleModalOpen(true);
								}}
							>
								<IconButton
									aria-label="schedule"
									component="span"
									disabled={
										loading ||
										recording ||
										ticketStatus !== "open" ||
										templateBarStatus
									}
									className={classes.attachBtn}
								>
									<SchedulesOutlinedIcon
										style={{
											color: "#ff5d00",
											marginRight: "0.5rem",
										}}
									/>
								</IconButton>
								Agendar
							</MenuItem>

							<MenuItem onClick={() => {
								handleMenuItemClick();
								setModalPix(true)
							}}>
								<IconButton
									component="span"
									disabled={
										loading ||
										recording ||
										ticketStatus !== "open" ||
										templateBarStatus
									}
									className={classes.attachBtn}

								>
									<AttachMoneyIcon
										style={{
											color: "#017BFC",
											marginRight: "0.5rem",
										}}
									/>
								</IconButton>
								PIX
							</MenuItem>

							<MenuItem onClick={handleMenuItemClick}>
								<FormControlLabel
									style={{ marginRight: 7, color: "gray" }}
									label={i18n.t("messagesInput.signMessage")}
									labelPlacement="start"
									control={
										<Switch
											size="small"
											checked={signMessage}
											onChange={(e) => {
												setSignMessage(e.target.checked);
											}}
											name="showAllTickets"
											color="primary"
										/>
									}
								/>
							</MenuItem>

						</Menu>
					</Hidden>



				)}
				<ModalPessoaValor
					open={modalPix}
					onClose={() => setModalPix(false)}
					onSave={handleSavePix}
				/>

				{!tailwickLayout && ticketChannel !== "email" && (
					<Hidden only={["md", "lg", "xl"]}>
						<IconButton
							aria-controls="simple-menu"
							aria-haspopup="true"
							onClick={handleOpenMenuClick}
						>
							<MoreVert />
						</IconButton>
						<Menu
							id="simple-menu"
							keepMounted
							anchorEl={anchorEl}
							open={Boolean(anchorEl)}
							onClose={handleMenuItemClick}
							anchorOrigin={{
								vertical: "top",
								horizontal: "left",
							}}
							transformOrigin={{
								vertical: "bottom",
								horizontal: "left",
							}}
						>
							<MenuItem onClick={handleMenuItemClick}>
								<IconButton
									aria-label="emojiPicker"
									component="span"
									disabled={
										loading ||
										recording ||
										ticketStatus !== "open" ||
										templateBarStatus
									}
									onClick={handleToggleReactionPicker}
									className={classes.emojiBtn}
								>
									<MoodIcon
										style={{
											color: `${darkMode ? "#fff" : "#00000"}`,
										}}
									/>
								</IconButton>
							</MenuItem>
							<MenuItem onClick={handleMenuItemClick}>
								<input
									multiple
									type="file"
									id="upload-button"
									disabled={
										loading ||
										recording ||
										ticketStatus !== "open" ||
										templateBarStatus
									}
									className={classes.uploadInput}
									onChange={handleChangeMedias}
								/>
								<label htmlFor="upload-button">
									<IconButton
										aria-label="upload"
										component="span"
										disabled={
											loading ||
											recording ||
											ticketStatus !== "open" ||
											templateBarStatus
										}
									>
										<AttachFileIcon className={classes.sendMessageIcons} />
									</IconButton>
								</label>
								<IconButton
									aria-label="schedule"
									component="span"
									disabled={
										loading ||
										recording ||
										ticketStatus !== "open" ||
										templateBarStatus
									}
									onClick={() => setScheduleModalOpen(true)}
								>
									<SchedulesOutlinedIcon className={classes.sendMessageIcons} />
								</IconButton>
							</MenuItem>
							<MenuItem onClick={handleMenuItemClick}>
								<FormControlLabel
									style={{ marginRight: 7, color: "black" }}
									label={i18n.t("messagesInput.signMessage")}
									labelPlacement="start"
									control={
										<Switch
											size="small"
											checked={signMessage}
											onChange={(e) => {
												setSignMessage(e.target.checked);
											}}
											name="showAllTickets"
											color="primary"
										/>
									}
								/>
							</MenuItem>
							{ticketChannel === "whatsappbusiness" && (
								<MenuItem>
									<Button
										disabled={loading || recording || ticketStatus !== "open"}
										onClick={() => setTemplateModalOpen(true)}
									>
										<WhatsAppIcon
											color={
												loading || recording || ticketStatus !== "open"
													? "disabled"
													: "primary"
											}
										/>
									</Button>
									<WabaSendTemplateModal
										open={templateModalOpen}
										closeModalFn={() => setTemplateModalOpen(false)}
										ticketId={ticketId}
									/>{" "}
								</MenuItem>
							)}
						</Menu>
					</Hidden>
				)}

				{tailwickLayout && ticketChannel !== "email" ? (
					<div
						className={clsx(
							classes.messageInputWrapper,
							"tailwick-composer-input-wrap"
						)}
					>
						{(ticketChannel === "whatsappbusiness" ||
							ticketChannel === "whatsapp_business_account") && (
							<>
								<button
									type="button"
									className="tailwick-composer-infield-btn"
									onClick={() => setTemplateModalOpen(true)}
									aria-label="Templates WhatsApp"
								>
									<WhatsAppIcon fontSize="small" />
								</button>
								{templateModalOpen && (
									<WabaSendTemplateModal
										whatsappId={whatsappId}
										open={templateModalOpen}
										closeModalFn={() => setTemplateModalOpen(false)}
										ticketId={ticketId}
									/>
								)}
							</>
						)}
						<button
							type="button"
							className={clsx(
								"tailwick-composer-infield-btn tailwick-composer-attach-btn",
								tailwickActionDisabled && "opacity-50",
								Boolean(anchorEl) && "tailwick-composer-attach-btn--open"
							)}
							disabled={tailwickActionDisabled}
							onClick={handleOpenMenuClick}
							aria-label="Anexar"
							aria-expanded={Boolean(anchorEl)}
						>
							<svg
								className="tailwick-composer-attach-btn__icon size-[20px] shrink-0"
								viewBox="0 0 24 24"
								fill="none"
								stroke="currentColor"
								strokeWidth="2"
								aria-hidden
							>
								<path d="M5 12h14" />
								<path d="M12 5v14" />
							</svg>
						</button>
						<TailwickComposerAttachMenu
							open={Boolean(anchorEl)}
							anchorEl={anchorEl}
							onClose={handleMenuItemClick}
							disabled={tailwickActionDisabled}
							darkMode={darkMode}
							onChangeMedias={handleChangeMedias}
							onCameraClick={handleCameraClick}
							onOpenContacts={() => setSendContactsModalOpen(true)}
							onOpenSchedule={() => setScheduleModalOpen(true)}
							onOpenPix={() => setModalPix(true)}
							signMessage={signMessage}
							onSignMessageChange={setSignMessage}
						/>
						{renderTailwickEmojiButton()}
						<InputBase
							inputRef={(input) => {
								input && input.focus();
								input && (inputRef.current = input);
							}}
							className={[
								classes.messageInput,
								ticketChannel === "email" ? classes.hiddenInput : "",
							].join(" ")}
							placeholder={
								ticketStatus === "open"
									? i18n.t("messagesInput.placeholderOpen")
									: i18n.t("messagesInput.placeholderClosed")
							}
							multiline
							maxRows={5}
							value={inputMessage}
							onChange={handleChangeInput}
							disabled={
								recording ||
								loading ||
								ticketStatus !== "open" ||
								templateBarStatus
							}
							onPaste={(e) => {
								ticketStatus === "open" && handleInputPaste(e);
							}}
							onKeyPress={(e) => {
								if (loading || e.shiftKey) return;
								if (e.key === "Enter") {
									handleSendMessage();
								}
							}}
						/>
						{typeBar ? (
							<ul className={classes.messageQuickAnswersWrapper}>
								{quickAnswers.map((value, index) => (
									<li
										className={classes.messageQuickAnswersWrapperItem}
										key={index}
									>
										{/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
										<a
											onClick={() => handleQuickAnswersClick(value)}
											style={{ color: "black" }}
										>
											{`${value.shortcut} - ${value.message} - ${value.file ? value.file : ""}`}
										</a>
									</li>
								))}
							</ul>
						) : null}
						<div className="tailwick-composer-input-end">
							{renderTailwickComposerActions()}
						</div>
					</div>
				) : (
					<>
				<div
					className={clsx(
						classes.messageInputWrapper,
						tailwickLayout && "tailwick-composer-input-wrap"
					)}
					style={{
						backgrounColor: `${darkMode ? "#fff" : "#000000"}`,
					}}>
					{!tailwickLayout && renderEmojiPickerPopover()}
					<InputBase
						inputRef={(input) => {
							input && input.focus();
							input && (inputRef.current = input);
						}}
						className={[
							classes.messageInput,
							ticketChannel === "email" ? classes.hiddenInput : "",
						].join(" ")}
						placeholder={
							ticketStatus === "open"
								? i18n.t("messagesInput.placeholderOpen")
								: i18n.t("messagesInput.placeholderClosed")
						}
						multiline
						maxRows={5}
						value={inputMessage}
						onChange={handleChangeInput}
						disabled={
							recording ||
							loading ||
							ticketStatus !== "open" ||
							templateBarStatus
						}
						onPaste={(e) => {
							ticketStatus === "open" && handleInputPaste(e);
						}}
						onKeyPress={(e) => {
							if (loading || e.shiftKey) return;
							if (e.key === "Enter") {
								handleSendMessage();
							}
						}}
						startAdornment={
							!tailwickLayout ? (
								<IconButton
									aria-label="emojiPicker"
									component="span"
									disabled={
										loading ||
										recording ||
										ticketStatus !== "open" ||
										templateBarStatus
									}
									onClick={handleToggleReactionPicker}
									className={classes.emojiBtn}
								>
									<MoodIcon
										style={{
											color: `${darkMode ? "#fff" : "#000000"}`,
										}}
									/>
								</IconButton>
							) : undefined
						}
					/>
					{typeBar ? (
						<ul className={classes.messageQuickAnswersWrapper}>
							{quickAnswers.map((value, index) => (
								<li
									className={classes.messageQuickAnswersWrapperItem}
									key={index}
								>
									{/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
									<a
										onClick={() => handleQuickAnswersClick(value)}
										style={{ color: "black" }}
									>
										{`${value.shortcut} - ${value.message} - ${value.file ? value.file : ""}`}
									</a>
								</li>
							))}
						</ul>
					) : (
						<div />
					)}
				</div>
				{inputMessage ? (
					<IconButton
						aria-label="sendMessage"
						component="span"
						onClick={handleSendMessage}
						disabled={loading || templateBarStatus}
						className={classes.iconeSendMessage}
						style={{ color: `${darkMode ? "#000000" : "#fff"}` }}
					>
						<SendIcon className={classes.sendMessageIcons} />
					</IconButton>
				) : recording ? (
					<div className={classes.recorderWrapper}>
						<IconButton
							aria-label="cancelRecording"
							component="span"
							fontSize="large"
							disabled={loading || templateBarStatus}
							onClick={handleCancelAudio}

						>
							<HighlightOffIcon className={classes.cancelAudioIcon} />
						</IconButton>
						{loading ? (
							<div>
								<CircularProgress className={classes.audioLoading} />
							</div>
						) : (
							<RecordingTimer key={recordingSessionId} />
						)}

						<IconButton
							aria-label="sendRecordedAudio"
							component="span"
							onClick={handleUploadAudio}
							disabled={loading || templateBarStatus}
						>
							<CheckCircleOutlineIcon className={classes.sendAudioIcon} />
						</IconButton>
					</div>
				) : (
					ticketChannel !== "email" && (
						<IconButton
							aria-label="showRecorder"
							component="span"
							disabled={loading || ticketStatus !== "open" || templateBarStatus}
							onClick={handleStartRecording}
							className={classes.iconeSendVoice}
						>
							<MicIcon className={classes.sendMessageIcons} style={{ color: `${darkMode ? "#fff" : "#000000"}`, }} />
						</IconButton>
					)
				)}
					</>
				)}
			</div>
		</Paper>
	);
}

export default MessageInput;
